import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import { getItemToken } from "../../../Utils/localStorageUtils";
import axios from "axios";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
function LifeTimeSubcription() {

  const baseURL = process.env.REACT_APP_Baseurl
  const headers = getItemToken('access_token')

  const labelSource = 'life-time-subscription'
  const editApi = `${baseURL}/admin/life-time-subscription`
  const updateApi = `${baseURL}/admin/life-time-subscription/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const currencyDefault = `${baseURL}/admin/currency_setting/index`


  const combinedRef = useRef({
    name: null,
    price: null,
    devices: null,
  });
  const [formData, setFormData] = useState()


  const [formDataError, setFormDataError] = useState({ body: "" })
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [symbol, setSymbol] = useState("");
  const [customFieldValues, setCustomFieldValues] = useState({});


  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
    devicesOption: [],
  })

  const fetchData = async () => {
    try {
      const response = await axios.get(`${editApi}`, { headers: headers });
      const result = response?.data;
      const data = result?.AdminLifeTimeSubscription;
      setFormData(data);
      setDefaultOption((prev) => ({
        ...prev,
        devicesOption: result?.devices,
      }));
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  const FetchCurrency = async () => {
    const response = await axios.get(`${currencyDefault}`, { headers: headers, })
      .then((response) => {
        var result = response?.data?.CurrencySetting?.symbol;
        setSymbol(result);
      })
      .catch((error) => console.log(error));
  }


  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const handleInput = (e) => {
    const { name, value, type, checked, id } = e.target;

    if (type === "checkbox") {
      if (name == "status") {
        setFormData((prev) => ({
          ...prev,
          [name]: checked ? 1 : 0,
        }));
      }
      if (name === "devices") {
        let deviceIds = (formData?.devices || "")
          .split(",")
          .filter((val) => val);

        const index = deviceIds.findIndex((val) => val === id.toString());
        if (index !== -1) {
          deviceIds?.splice(index, 1);
        } else {
          deviceIds?.push(id.toString());
        }
        const devices = deviceIds.join(",");
        setFormData({ ...formData, devices });
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          devices: "",
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          [name]: checked ? 1 : 0,
        }));
      }

    }

    if (type === 'text' || type == "number") {
      if (type === "number" && (value === "-" || Number(value) < 0)) {
        return;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }

  };

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.name || formData.name.trim().length < 3 || formData.name.trim().length > 100) {
      let errorMessage = "";
      if (!formData?.name) {
        errorMessage = "Name cannot be empty.";
      } else if (formData.name.trim().length < 3) {
        errorMessage = "Name must be at least 3 characters.";
      } else if (formData.name.trim().length > 100) {
        errorMessage = "Name cannot exceed 100 characters.";
      }
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        name: errorMessage,
      }));
      combinedRef.current['name'].focus();
      formIsValid = false;
    }
    if (!formData?.price) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        price: "Price cannot be empty.",
      }));
      combinedRef.current['price'].focus()
      formIsValid = false;
    }
    if (!formData?.devices) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        devices: "Enable any one of the devices.",
      }));
      formIsValid = false;
    }
    return formIsValid;
  }

  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["name", "price", "devices", "status"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios.post(`${updateApi}`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = (formData && formData.id) || result?.id;
          await saveCustomFieldsStrict({ baseURL, headers, entityType: 'plan', entityId, values: customFieldValues });
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }
        setShowOverlay(false);
        toast.success(result?.message)
        setWithOutRefresh(!withOutRefresh)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }
  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }


  useEffect(async () => {
    await fetchData();
    await labelFetch()
    await FetchCurrency()

  }, [withOutRefresh]);
  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={labelDisplay?.[0]?.title} saveText={labelDisplay?.[6]?.title} saveMethod={handleStore} />

      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageLabel text={labelDisplay?.[1]?.title} className="mandatorySimple" />
            <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Name "} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} />
            <MessageLabel text={`${labelDisplay?.[2]?.title} (${symbol})`} className="mandatorySimple" />
            <AdminCustomInput type="number" name="price" value={formData?.price} onChange={handleInput} placeHolder="Price" min={1} maxLength={9} ref={(el) => (combinedRef.current.price = el)} error={formDataError?.price} restrictNumberInput />

            <div className="card p-3 mt-3">
              {/* <MessageHeading text="Additional Fields" /> */}
              {/* Custom fields  */}
              <FieldRenderer2
                pageIdentifier={"plans.edit"}
                entityType="plan"
                entityId={formData?.id || null}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={"plans.edit"}
                entityType="plan"
                entityId={formData?.id || null}
                onChange={setCustomFieldValues}
              />
            </div>
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[3]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[4]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'status'} checked={formData?.status == 1} onChange={handleInput} />
              </div>
            </div>
            <MessageLabel text={labelDisplay?.[5]?.title} className="mandatorySimple" />
            {formDataError?.devices && (<MessageBox text={`${formDataError?.devices}`} classname='errorred mb-2 d-block' />)}

            {defaultOption?.devicesOption?.map((item, index) => {
              const deviceIds = formData?.devices?.split(",");
              const isChecked = deviceIds?.some((val) => val === item?.id.toString());
              return (
                <div className="d-flex justify-content-between mb-2 " key={item?.id}>
                  <div className="col-6 col-md-6 pe-2">
                    <MessageSubHeading text={item?.devices_name} />
                  </div>
                  <div className="col-6 col-md-6 ps-2 text-end">
                    <AdminSwitch name="devices" id={item?.id} checked={isChecked} onChange={handleInput} />
                  </div>
                </div>
              );
            })}
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default LifeTimeSubcription;